/**
 * Date-extensions locale Russian [ru]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ru', {
    monthNames: ['январь','февраль','март','апрель','май','июнь','июль','август','сентябрь','октябрь','ноябрь','декабрь'],
    monthShortNames: ['янв.','февр.','март','апр.','май','июнь','июль','авг.','сент.','окт.','нояб.','дек.'],
    dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
    dayShortNames: ['вс','пн','вт','ср','чт','пт','сб']
});
